import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { ClaimTypes } from '../models/claim-types.model';
import { MeClient } from '../services/api-client';

export const hasOrganizationsGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(MeClient)
    .getScopeParameterValues(ClaimTypes.Organization)
    .pipe(map((organizations) => (organizations.length > 0 ? true : router.parseUrl('errors/403'))));
};
